//http://facebook.github.io/fixed-data-table/example-object-data.html
import React from 'react'
import _ from 'lodash'
import ReactTable from 'react-table'
import { Link } from 'react-router'
import * as request from 'superagent'
import fetch from 'node-fetch'
import NoCache from 'superagent-no-cache'
import { getToken } from '../Commons/Authentication'
import NavigationBar from '../Commons/NavigationBar'
import { ToastContainer, ToastMessage } from 'react-toastr'
import SearchImage from '../../img/icons/general-icons/search_icon.png'
import LinkDashboard from './LinkDashboard'
import LinkImageDashboard from './LinkImageDashboard'
import LinkMedicalData from './LinkMedicalData'
import LinkUpdatePatient from './LinkUpdatePatient'
import NotDataAvailable from './NotDataAvailable'
import EditIcon from '../../img/icons/general-icons/icon_edit.png'
import DashboardIcon from '../../img/icons/general-icons/icon_dashboard.png'
import PatientIcon from '../../img/icons/general-icons/add_user_icon.png'
import moment from 'moment'

const ToastMessageFactory = React.createFactory(ToastMessage.animation)
var timer;
export default class SearchPatient extends React.Component {
  constructor(props) {
    super(props)
    this.state = ({ patientList: [], showTable: true, classLink: 'form-field-new-patient', griddleHeight: 350, loader: 'all', classContainer: 'form-page-container hide', rendervar: true })
    this.listPatients()
    this.selectGroup()
  }
  componentWillMount() {
    this.loadUserData()
  }
  loadUserData() {
    let endpoint = 'api/v1/user/find'
    request
      .get(endpoint)
      .set('Authorization', `Bearer ${getToken()}`)
      .use(NoCache)
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err) console.log('nologueado')
        else {
          if (res.body.nombrecompleto !== '' && res.body.nombrecompleto !== undefined) {
            this.setState({ user: res.body.nombrecompleto, rol: res.body.rol[0].nombre })
          } else {
            this.setState({ user: res.body.email, rol: res.body.rol[0].nombre })
          }
          console.log(res.body.rol[0].nombre)
        }
      })
  }
  exportFunction() {
    this.refs.container.success('Espera se esta generando csv...', '', {
      timeOut: 10000,
      closeButton: true
    })
    const redirect = () => {
      let headers = {
        'Authorization': `Bearer ${getToken()}`,
        'Content-Type': 'text/csv'
      }
      const url = '/api/v1/export/relations=[paciente,estadoDeSaludData]'
      const getBlob = fetch(url, { headers })
        .then(response => response.blob())
      getBlob.then((data) => {
        console.log(data)
        var csvURL = window.URL.createObjectURL(data)
        let tempLink = document.createElement('a')
        tempLink.href = csvURL
        tempLink.setAttribute('download', `pacientes_${moment().format('DDMMYYYYHHmm')}.csv`)
        tempLink.click()
      })

    }
    setTimeout(redirect, 3000)
    this.refs.container.success('El documento csv se descargo espera 10 segundos y revisa descargas.', '', {
      timeOut: 15000,
      closeButton: true
    })

  }
  listPatients() {
    request
      .get('api/v1/patient/findEspecial/')
      .set('Authorization', 'Bearer ' + getToken())
      // .use(NoCache)
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (res) {
          this.setState({ patientList: res.body, classContainer: 'form-page-container', loader: 'hide', rendervar: true })
        } else {
          if (err) {
            this.setState({ rendervar: false })
            this.refs.container.error('Algo inesperado ocurrió, no se encontraron pacientes', '', {
              closeButton: true
            })
          }
        }
      })
  }
  showPatientTable() {
    this.setState({ showTable: true })
  }

  findTypeAhead() {
    try {
      clearTimeout(timer); // stop timeout change event if it's already running
    } catch (ignore) { }
    timer = setTimeout(() => {
      this.findData_b();
    }, 800);
  }
  findData_b() {
    console.log('aqui')
    let val = this.refs.query.value
    let sede = this.refs.sede.value
    console.log(sede)
    let url = `api/v1/patient/typehead?str=${val}&&grupo=${sede}`
    this.setState({ 'url': val, classLink: 'form-field-new-patient' })
    request
      .get(url)
      .set('Authorization', 'Bearer ' + getToken())
      // .use(NoCache)
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (res) {
          if (!_.isEmpty(res.body)) {
            this.setState({ patientList: res.body, griddleHeight: 350, rendervar: true })
            this.showPatientTable()
          } else if (_.isEmpty(res.body)) {
            console.log('vacio men')
            this.setState({ patientList: {}, griddleHeight: 20, rendervar: false })
            this.showPatientTable()
            if (isNaN(val)) { } else {
              this.refs.container.success('Puedes Intentar Ingresar un nuevo paciente Con esta identificación', '', {
                timeOut: 30000,
                closeButton: true
              })
              this.setState({ 'url': val, classLink: 'form-field-new-patient animated tada' })
            }
          } else {
            if (err) {
              this.refs.container.error('No se encontro información del paciente', '', {
                closeButton: true
              })
            }
          }
        }
      })
  }
  selectGroup() {
    request
      .get('api/v1/patient/select/')
      .set('Authorization', 'Bearer ' + getToken())
      .use(NoCache)
      .set('Accept', 'application/json')
      .end((err, result) => {
        if (result) {
          let data = result.body.group
          this.setState({ 'select': data })
        } else {
          if (err) {
            console.log(err)
            this.setState({ render: false })
            // this.refs.container.error('Algo inesperado ocurrió, no se encontraron grupos', '', {
            //   closeButton: true
            // })
          }
        }
      })
  }
  render() {
    // var cOptions = this.state.select.map(function (item, index) {
    //   return <option value={item.nombre}>{item.nombre}</option>
    // })
    // console.log(this.state.griddleHeight)
    var cOptions
    if (!_.isEmpty(this.state.select)) {
      let arrayElements = this.state.select
      cOptions = arrayElements.map(function (item, index) {
        return <option key={`op${index}`} value={item._id}>{item.nombre}</option>
      })
    }
    document.title = 'Listado de Pacientes - CORE 3.0'
    var information = this.state.patientList
    var patientsData = []
    /*var columnsData = [
      {
        'columnName': 'Identificación',
        'customComponent': LinkDashboard
      },
      {
        'columnName': 'Nombre',
        'customComponent': LinkDashboard
      },
      {
        'columnName': 'Entidad',
        'customComponent': LinkDashboard
      },
      {
        'columnName': 'Grupo',
        'customComponent': LinkDashboard
      },
      {
        'columnName': 'Ciudad',
        'customComponent': LinkDashboard
      },
      {
        'columnName': 'Toma de datos',
        'customComponent': LinkMedicalData
      },
      {
        'columnName': '',
        'customComponent': LinkImageDashboard
      },
      {
        'columnName': ' ',
        'customComponent': LinkUpdatePatient
      }
    ]
    var options = []
    _.forEach(information, (key, vals) => {
      var date
      if (key.date === 'empty') {
        date = 'Sin datos médicos'
      } else {
        date = moment(key.date, 'x').format('DD/MM/YYYY')
      }
      patientsData.push({
        'Identificación': key.numeroDocumento,
        'Nombre': key.nombres + ' ' + key.apellidos,
        'Entidad': key.eps[0].nombre,
        'Grupo': key.grupo[0].nombre,
        'Ciudad': key.ciudad,
        'Toma de datos': date,
        '': DashboardIcon,
        ' ': EditIcon
      })
    }) */
    var url = 'patient/'
    if (_.isEmpty(this.state.url)) {
      url = 'patient/'
    } else {
      url = `patient/${this.state.url}`
    }
    const columns = [

      {
        columns: [{
          header: 'Identificación',
          accessor: 'numeroDocumento'
        }]
      },
      {
        columns: [{
          header: 'Nombres',
          accessor: 'nombres'
        }, {
          header: 'Apellidos',
          id: 'lastName',
          accessor: 'apellidos'
        }]
      },
      {
        columns: [{
          header: 'Eps',
          accessor: 'eps'
        }]
      },
      {
        columns: [{
          header: 'Grupo',
          accessor: 'grupo'
        }]
      },
      {

        columns: [{
          expander: true,
          header: () => (<strong>Toma de datos</strong>),
          width: 120,
          render: ({ isExpanded, row }) => (
            <div>
              {isExpanded}
              <LinkMedicalData numeroDocumento={row.numeroDocumento} data={row.fecha} />
            </div>
          ),
          style: { cursor: 'pointer', fontSize: 25, padding: '0', textAlign: 'center', userSelect: 'none' }
        }]
      }, {

        columns: [{
          expander: true,
          header: () => (<strong>Dashboard</strong>),
          width: 80,
          render: ({ isExpanded, row }) => (
            <div>
              {isExpanded}
              <LinkImageDashboard numeroDocumento={row.numeroDocumento} />
            </div>
          ),
          style: { cursor: 'pointer', fontSize: 25, padding: '0', textAlign: 'center', userSelect: 'none' }
        }]
      }
      , {
        columns: [{
          expander: true,
          header: () => (<strong>Editar</strong>),
          width: 65,
          render: ({ isExpanded, row }) => (
            <div>
              {isExpanded}
              <LinkUpdatePatient numeroDocumento={row.numeroDocumento} />
            </div>
          ),
          style: { cursor: 'pointer', fontSize: 25, padding: '0', textAlign: 'center', userSelect: 'none' }
        }]
      }
    ]
    var rendervar = this.state.rendervar
    return (
      <div className='form-page-container'>
        <NavigationBar />

        <div className={this.state.loader}>
          <div className='loader'>
          </div>
        </div>

        <div className={this.state.classContainer}>
          <ToastContainer toastMessageFactory={ToastMessageFactory} ref='container' className='toast-top-right' />
          <div className='form-field-container'>
            <img className='form-field-image' src={SearchImage} />
            <input id='searchPatient' ref='query' className='form-input-search' onChange={(e) => { this.findTypeAhead() }} type='text' placeholder='Buscar paciente....' />
            <select id='sede' ref='sede' className='group-select' onChange={(e) => { this.findTypeAhead() }} >
              <option value=''>Todos</option>
              {cOptions}
            </select>
            {(this.state.rol == 'admin')
              ?
              <div className='export'>
                <a className='link-report-data icon-icon-57-document-download' onClick={this.exportFunction.bind(this)} target='_blank' download></a>
              </div>
              : null
            }
          </div>
          <div className='table-container'>
            {rendervar ?
              <ReactTable
                className='-striped -highlight'
                data={information}
                columns={columns}
                showFilters={true}
                defaultPageSize={10}
              />
              :
              ''
            }

          </div>
          {(this.state.griddleHeight === 20)
            ? <div className={this.state.classLink}>
              <img className='form-field-image' src={SearchImage} />
              <Link className='form-link-new-patient' to={url}>Buscar paciente en el Core 2.0</Link>
              <img className='form-field-image' src={PatientIcon} />
              <Link className='form-link-new-patient' to={url}>Ingresar nuevo paciente</Link>
            </div>
            : <div className={this.state.classLink}>
              <img className='form-field-image' src={PatientIcon} />
              <Link className='form-link-new-patient' to={'patient'}>Ingresar nuevo paciente</Link>
            </div>
          }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Search/SearchComponent.js